var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{style:({
    //height: `${100 - offsetY / 4 > 50 ? 100 - offsetY / 4 : '50'}vh`,
  }),attrs:{"id":"front","fluid":""}},[_c('div',{staticClass:"d-flex flex-column align-center",style:({
      position: 'absolute',
      transform: ("translate(0," + (_vm.offsetY / 3) + "px)"),
      opacity: ("" + (1 - _vm.offsetY / 280)),
    })},[_c('div',[_c('v-icon',{attrs:{"size":"220"}},[_vm._v("$logo")])],1),_c('div',{staticClass:"industry"},[_c('div',{staticClass:"prof",attrs:{"dark":""}},[_vm._v("Stacja kontroli pojazdów")]),_c('v-card',{staticClass:"division mx-8",attrs:{"rounded":"0","elevation":"0","color":"primary"}}),_c('div',{staticClass:"prof"},[_vm._v("Warsztat samochodowy")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }